import { Contact } from "../../components/contact"
import './index.scss';

export const ContactPage = () => {
    return(
        <div className="contact-page">
            <Contact/>
        </div>
    )
}